import { Button, Modal, ModalFooter } from "@healthos/ui";
import { useAwayRefreshPrompt } from "../hooks/use-away-refresh-prompt";
import { useHostPlatform } from "../hooks/use-host-platform";

interface AwayRefreshModalProps {
  isSignedIn: boolean;
}

export function AwayRefreshModal({ isSignedIn }: AwayRefreshModalProps) {
  const { platform } = useHostPlatform();
  const isDesktop = platform === "desktop";
  const { open, dismiss } = useAwayRefreshPrompt({ enabled: isDesktop && isSignedIn });

  if (!isDesktop) return null;

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) dismiss();
      }}
      title="Welcome back"
      description="You've been away for a while. Refresh to load the latest?"
      size="sm"
    >
      <ModalFooter>
        <Button variant="ghost" onClick={dismiss}>
          Not now
        </Button>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </ModalFooter>
    </Modal>
  );
}
